module.exports = __webpack_public_path__ + "img/pr-15.9d704d9d.png";